export default __webpack_public_path__ + "assets/game/speles_punts_unselected_default.png";